import { z } from 'zod/v4'
import { assetMediaSchema } from '../assets/assetDataTypes.ts'
import { type Enums, type Tables } from '../db/supabase.types.ts'

export const userProfileDataSchema = z.looseObject({
  name: z.string().optional(),
  title: z.string().optional(),
  avatar_url: z.string().optional(),
  office: z.string().optional(),
  intro: z.string().optional(),
})

export type UserProfileDataType = z.infer<typeof userProfileDataSchema>

export const organisationSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  email_domain: z.string(),
  logo_media: assetMediaSchema.nullable(),
  created_at: z.string(),
  updated_at: z.string().nullable(),
})

export type Organisation = z.infer<typeof organisationSchema>

export type ParsedUserProfile = Omit<Tables<'user_profile'>, 'data'> & {
  data: UserProfileDataType
  roles: Enums<'user_role'>[]
  organisation: Organisation | null
}

export type RealtorUserProfile = ParsedUserProfile & {
  phone: string | null
  email: string | null
}

export type OtpContactType = 'email' | 'phone'

export type ContactMethod = {
  type: OtpContactType
  value: string
}

export const authUserMetadataSchema = z.looseObject({
  language: z.string().optional(),
})

export type AuthUserMetadata = z.infer<typeof authUserMetadataSchema>
